import { IAuthSlice } from "redux/types";
import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "../../api/index";

const initialState: IAuthSlice = {
    accessToken: "",
    loginErr: "",
    onLoginSuccess: false
};

export interface ILoginPayload {
    username: string, password: string
}

type LoginThunk = AsyncThunk<string, ILoginPayload, {}>

export const login: LoginThunk = createAsyncThunk("auth/login", async (payload) => {

    const { data } = await api.loginReq(payload)

    return data.accessToken

})

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: state => {
            return {
                ...state,
                accessToken: ""
            }
        },
        resetLoginSuccess: state => {
            return {
                ...state,
                onLoginSuccess: false,
                loginErr: ""
            }
        }
    },
    extraReducers(builder) {
        builder.addCase(login.fulfilled, (state, action) => {

            return {
                ...state,
                accessToken: action.payload,
                onLoginSuccess: true,
                loginErr: ""
            }
        })
        builder.addCase(login.rejected, (state, action) => {
            return {
                ...state,
                loginErr: "Şifre veya kullanıcı adı hatalı!"
            }
        })
    }
})

export const { logout, resetLoginSuccess } = authSlice.actions

export default authSlice.reducer